import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import {PasswordResetRequest} from "../utils/types";
import {passwordResetRequest} from "../apis/junkyard";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface ForgotPasswordProps {
  open: boolean;
  handleClose: () => void;
}

export default function ForgotPassword({ open, handleClose }: ForgotPasswordProps) {

  const [email, setEmail] = useState<string | undefined>(undefined);
  const [showSuccess, setShowSuccess] = React.useState<boolean | undefined>(undefined);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const handlePasswordReset = async (email: string) => {

    setIsLoading(true)

    try {
      const resetRequestResponse = await passwordResetRequest({"email": email} as PasswordResetRequest);
      if (resetRequestResponse.success) {
        setShowSuccess(true)
        setIsLoading(false);
        return;
      }
    } catch (error) {
      console.error("Error requesting password reset", error)
    }
    setShowSuccess(false);
    setIsLoading(false);
  };

  const doClose = async () => {

    setShowSuccess(undefined);
    setEmail(undefined);
    handleClose();
  }


  return (
    <Dialog
      open={open}
      onClose={doClose}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            if (email) handlePasswordReset(email);
          },
          sx: { backgroundImage: 'none' },
        },
      }}
    >
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <DialogContentText>
          Enter your account&apos;s email address, and we&apos;ll send you a link to
          reset your password.
        </DialogContentText>
        <OutlinedInput
          autoFocus
          required
          margin="dense"
          id="email"
          name="email"
          label="Email address"
          placeholder="Email address"
          type="email"
          fullWidth
          onChange={(event) => {setEmail(event.target.value)}}
        />
      </DialogContent>
      {isLoading && (
          <Box sx={{margin: 2, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <CircularProgress />
          </Box>
        )
      }
      {!isLoading && showSuccess === undefined && (
              <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" type="submit">
                  Continue
                </Button>
              </DialogActions>
        )}
      {!isLoading && showSuccess === true && (
          <Alert severity="success">Success, please check your email.</Alert>
      )}
      {!isLoading && showSuccess === false && (
          <Alert severity="error">Failed to request password reset</Alert>
      )}
    </Dialog>
  );
}